module.exports = __webpack_public_path__ + "img/free_multiplier_2.8357f647.png";